import React from "react";
import PropTypes from "prop-types";

const LoadingSpinner = (props) => {
  const { type, color } = props;

  return (
    <div
      data-testid="loading-spinner"
      className="d-flex w-100 justify-content-center"
    >
      <div className={`spinner-${type} text-${color}`} role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

LoadingSpinner.propTypes = {
  type: PropTypes.oneOf(["grow", "border"]),
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "light",
    "dark",
  ]),
};

LoadingSpinner.defaultProps = {
  type: "grow",
  color: "secondary",
};

export default LoadingSpinner;
